import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaCheckCircle } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import User from '../../images/user.jpg';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';
import { FcCancel } from "react-icons/fc";

function ProfileScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(false);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ 'f_name': '', 'l_name': '', 'm_name': '', 'streak': '', 'dob': '', 'classes': [], 'attendance': 0 });
    // const [updateTutorAccount, setUpdateTutorAccount] = useState({ bank_code: '', bank_name: '', account_number: '',  })

    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/profile/tutor-profile.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setProfileData({'full_name': response.data.results.full_name, 'date_joined': response.data.results.date_joined, 'phone': response.data.results.phone, 'email': response.data.results.email, 'classes': response.data.results.active_classes_enrrolled, 'attendance': response.data.results.attendance, 'tutor_account_set': response.data.results.tutor_account_set, 'tutor_account_details': response.data.results.tutor_account_details });
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[70%] p-0 lg:p-6 space-y-6 min-h-screen">
                        <div className="max-w-5xl mx-auto p-0 space-y-8">
                            {/* Personal Details */}
                            <div className="bg-white shadow rounded-xl p-6 space-y-4">
                                <h2 className="text-lg font-semibold text-gray-700">Personal Details</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                                <div>
                                    <span className="font-medium">Full Name:</span> {profileData?.full_name}
                                </div>
                                <div>
                                    <span className="font-medium">Email:</span> {profileData?.email}
                                </div>
                                <div>
                                    <span className="font-medium">Phone:</span> {profileData?.phone}
                                </div>
                                <div>
                                    <span className="font-medium">Joined:</span> {profileData?.date_joined}
                                </div>
                                </div>
                            </div>

                            {/* Assigned Classes */}
                            <div className="bg-white shadow rounded-xl p-6 space-y-4">
                                <h2 className="text-lg font-semibold text-gray-700">Assigned Classes</h2>
                                <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                                    {profileData?.classes?.map((lang, index) => (
                                        <li key={index}>{lang}</li>
                                    ))}
                                </ul>
                            </div>

                            {/* Withdrawal Account */}
                            <div className="bg-white shadow rounded-xl p-6 space-y-4">
                                <div className='w-full flex flex-row justify-between items-center'>
                                    <h2 className="text-lg font-semibold text-gray-700">Withdrawal Account Details</h2>
                                    {profileData?.tutor_account_set ? (
                                        <div className='flex flex-row items-center gap-x-2'>
                                            <FaCheckCircle size={20} color='#00b47a' />
                                            <label className='text-sm text-[#00b47a]'>Settlement Enabled</label>
                                        </div>
                                    ) : (
                                        <div className='flex flex-row items-center gap-x-2'>
                                            <FcCancel size={20} color='#d40000' />
                                            <label className='text-sm text-[#d40000]'>Settlement Disabled</label>
                                        </div>
                                    )}
                                </div>
                                <form className="space-y-4">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                    <label className="block text-sm font-medium text-gray-600 mb-1">Bank Name</label>
                                    <input
                                        readOnly
                                        value={profileData?.tutor_account_details?.bank_name || 'Not Set'}
                                        type="text"
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow"
                                        placeholder="Enter bank name"
                                    />
                                    </div>
                                    <div>
                                    <label className="block text-sm font-medium text-gray-600 mb-1">Account Number</label>
                                    <input
                                        value={profileData?.tutor_account_set ? '*********' : 'Not Set'}
                                        readOnly
                                        type="text"
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow"
                                        placeholder="Enter account number"
                                    />
                                    </div>
                                    <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-gray-600 mb-1">Account Name</label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={profileData?.tutor_account_details?.account_name || 'Not Set'}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-yellow"
                                        placeholder="Enter account name"
                                    />
                                    </div>
                                </div>
                                </form>
                            </div>
                            </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default ProfileScreen;
